import { render, staticRenderFns } from "./RaddarChart.vue?vue&type=template&id=bafd8c8c"
import script from "./RaddarChart.vue?vue&type=script&lang=js"
export * from "./RaddarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bafd8c8c')) {
      api.createRecord('bafd8c8c', component.options)
    } else {
      api.reload('bafd8c8c', component.options)
    }
    module.hot.accept("./RaddarChart.vue?vue&type=template&id=bafd8c8c", function () {
      api.rerender('bafd8c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/RaddarChart.vue"
export default component.exports